export const AUTH_URL_BASE = "https://accounts.google.com/o/oauth2/v2/auth";
export const AUTH_CALLBACK_PATH = "/auth/google/callback";
export const TOKEN_EXCHANGE_ENDPOINT = "/api/google/auth/exchange-code";
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const SCOPES = [
  "https://www.googleapis.com/auth/classroom.courses.readonly",
  "https://www.googleapis.com/auth/classroom.rosters.readonly",
  "https://www.googleapis.com/auth/classroom.profile.emails",
];
export const TOKEN_NAME = "google_access_token";
export const LOGIN_FAILED = "google_login_failed";
export const GOOGLE_OAUTH_STATE = "google_oauth_state";
export const IMPORT_ORIGINS = {
  GOOGLE_CLASSROOM: "google_classroom",
};
export const REDIRECT_STATUSES = [401, 403];
export const IMPORT_STARTED = "import_started";
